import { useState } from 'react';
import { Box, Button, Card, Spinner, Tabs } from '@nimbus-ds/components';
import { combineStatus } from 'commons/utils/combineStatus';
import { useGetIsFreePlan, useStoreStatus } from 'domains/Auth/hooks';
import { getMainConceptFromCharges } from 'domains/Billing/Checkout/hooks/utils';
import { trackingBillingStartPayment } from 'domains/Billing/Checkout/tracking';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { LastPayments, SelectChargesToPayTab } from './components';
import {
  useNoChargesMessage,
  useSelectCharges,
} from './components/SelectChargesToPayTab/hooks';
import { useManualPaidCharges } from '../../hooks';

function PaymentsTabs() {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.paymentsTabs',
  );
  const { storeStatus } = useStoreStatus();
  const { isTrial } = useGetIsFreePlan();

  const {
    chargesToSelect,
    status: chargesStatus,
    isCreatingPayOrder,
    onPay,
    selectedCharges,
  } = useSelectCharges();
  const { manualPaidCharges, status } = useManualPaidCharges(
    chargesToSelect?.length === 0,
  );

  const handleOnPay = () => {
    const mainConcept = getMainConceptFromCharges(selectedCharges);
    trackingBillingStartPayment(false, mainConcept);
    onPay();
  };

  const [tabIndex, setTabIndex] = useState(0);

  const { status: noChargesStatus, nextExecutionDate } = useNoChargesMessage();

  const { isSuccess } = combineStatus(status, chargesStatus, noChargesStatus);

  const shouldShowChargesTab =
    chargesToSelect?.length ||
    isTrial ||
    storeStatus === 'store_down' ||
    nextExecutionDate;
  const shouldShowLastPaymentsTab = manualPaidCharges?.length;

  if (isSuccess && !shouldShowChargesTab && !shouldShowLastPaymentsTab)
    return null;

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Card padding="none">
        <Box marginTop="2">
          <Tabs
            selected={tabIndex}
            onTabSelect={(index) => {
              setTabIndex(index);
            }}
          >
            <Tabs.Item label={t('toPay.tabTitle')}>
              <SelectChargesToPayTab />
            </Tabs.Item>
            <Tabs.Item label={t('lastPayments.tabTitle')}>
              <LastPayments />
            </Tabs.Item>
          </Tabs>
        </Box>
      </Card>

      {tabIndex === 0 && isSuccess && (
        <Box display="flex" justifyContent="flex-end">
          <Button
            disabled={
              isCreatingPayOrder ||
              !selectedCharges ||
              selectedCharges.length <= 0
            }
            appearance="primary"
            onClick={handleOnPay}
          >
            {t('toPay.continueToPay')}
            {isCreatingPayOrder && <Spinner size="small" />}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default PaymentsTabs;
